module.exports = __webpack_public_path__ + "static/img/akum_120.4fdba02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akum_120.svg
// module id = CRYZ
// module chunks = 1